import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import GetDomains from '../projectmgmt/GetDomains'
import Loader from 'react-loader-spinner';
import Select from 'react-select';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DheeTranscriptionApi from './dhee-transcription-api';

class ASRDemo extends Component {
    constructor() {
        super();
        this.state = {
            apiData: {},
        },
            this.languageList = []
    }

    handleClickMic = () => {
        var micButton = document.getElementById("mic");
        if (window.transcriptionApi.isListening()) {
            micButton.className = "fa fa-microphone";
            window.transcriptionApi.stop();
        } else {
            micButton.className = "fa fa-refresh fa-spin";
            micButton.style.color = "rgb(113, 115, 167)";
            window.transcriptionApi.start();
        }
    }

    transcript = () => {
        if (window.transcriptionApi && window.transcriptionApi.isListening()) {
            window.transcriptionApi.stop();
        }
        var transcriptionTarget = document.getElementById("transcript");
        transcriptionTarget.value = "";
        var micButton = document.getElementById("mic");
        var selectedLanguage = document.getElementById("language").value;
        var developerId = JSON.parse(localStorage.getItem("user_details")).userId;

        var config = {
            apiKey: this.state.apiData.key,
            apiSecret: this.state.apiData.secret,
            language: selectedLanguage,
            targetContainer: transcriptionTarget,
            micButton: micButton,
            callParams: { "developerId": developerId }
        }
        var lookup = {
            "developer.dhee.ai": "runtime.dhee.ai",
            "developers.dhee.ai": "runtime.dhee.ai",
            "developers-azure.dhee.ai": "runtime-azure.dhee.ai",
            "dev-cloud.dhee.net.in": "dev-runtime.dhee.net.in"
        };
        const MY_SERVER = lookup[window.location.host];
        window.transcriptionApi = new DheeTranscriptionApi(config);
        window.transcriptionApi.MY_SERVER = MY_SERVER;
        DheeTranscriptionApi.MY_SERVER = MY_SERVER;
        window.transcriptionApi.setEventHandler("startRecording", function () {
            micButton.className = "fa fa-microphone";
            micButton.style.color = "red";
        });
        window.transcriptionApi.setEventHandler("stopRecording", function () {
            micButton.className = "fa fa-microphone";
            micButton.style.color = "#282a65";
        });
    }

    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchLanguagesApi();
            thisController.fetchAsrApis();
            thisController.transcript();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            thisController.languageList = [];
            thisController.projectId = event.projectId;
            thisController.fetchLanguagesApi(event.projectId);
            thisController.fetchAsrApis(event.projectId);
            thisController.transcript();
        })
    }

    fetchAsrApis = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        $.ajax({
            url: "/api/api-key/api-type",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                apiType: "ASR_API"

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.apiData = res.result[0];
                        thisController.setState(thisController.state);
                    } else {
                        thisController.notifyNotAdded("Oops!you have not added Api Keys");
                        setTimeout(function () {
                            window.location.href = '/platform/cloud-asr/api-keys';
                        }, 3000);
                    }
                } else {
                    thisController.notifyNotAdded("Oops!you have not added Api Keys");
                    setTimeout(function () {
                        window.location.href = '/platform/cloud-asr/api-keys';
                    }, 3000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchLanguagesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var asrdemoController = this;
        asrdemoController.languageList = [];
        $.ajax({
            url: "/api/project-languages-selected",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length !== 0) {
                        asrdemoController.languageList = res.result;
                        asrdemoController.setState(asrdemoController.state);
                    } else {
                        asrdemoController.notifyNoLangSelected();
                    }
                } else {
                    asrdemoController.notifyFailToLoadLanguages(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyFailToLoadLanguages() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyNoLangSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
            position: "top-center"
        });
    }

    notifyNotAdded(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    resetData = () => {
        var transcriptionTarget = document.getElementById("transcript");
        transcriptionTarget.value = "";
        var micButton = document.getElementById("mic");
        micButton.className = "fa fa-microphone";
        if (window.transcriptionApi && window.transcriptionApi.isListening()) {
            micButton.style.color = "#282a65";
            window.transcriptionApi.stop();
        }
        this.setState(this.state);
    }

    componentWillUnmount() {
        if (window.transcriptionApi && window.transcriptionApi.isListening()) {
            window.transcriptionApi.stop();
        }
    }

    handleClickCopy = () => {
        var copyText = document.getElementById("transcript");
        copyText.select();
        copyText.setSelectionRange(0, 99999)
        document.execCommand("copy");
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={false}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />

                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* for reactToast */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/material.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />

                {/* Content Wrapper. Contains page content */}
                <div className="wrapper" style={{ height: "450px", backgroundColor: "#FFFFFF", overflow: 'hidden' }}>
                    <ToastContainer className="Toast-at-center" />
                    <div className="row">
                        <div className="col-sm-3" style={{ marginTop: "30px", marginLeft: "20px" }}>
                            <select id="language" onChange={this.transcript}
                                style={{ width: '80%', height: '30px', borderRadius: '5px', background: 'white' }}>
                                {this.languageList.map((language) =>
                                    <option value={language.code}>{language.name}</option>
                                )}
                            </select>
                        </div >
                        <div className="col-sm-8" align="right" style={{ marginTop: "30px" }}>
                            <button onClick={this.resetData} type="button" className="btn action-button">
                                Reset
                            </button>
                            <button className="btn action-button" title="copy content" onClick={this.handleClickCopy}><img src="./assets/images/copy.png" /></button>
                        </div>
                        <label style={{ marginLeft: "25px" }}>
                            Try our ASR, by recording your speech using microphone icon below
                        </label>
                    </div>
                    <div className="container-fluid row" align="center" style={{ marginTop: "15px" }}>
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6">
                            <textarea
                                style={{
                                    background: 'white', resize: 'none', minHeight: "200px", height: "100%", width: "100%",
                                    fontSize: "14px", borderRadius: "10px"
                                }}
                                className="form-control"
                                id="transcript"
                            /><br />
                            <i className="fa fa-microphone" onClick={this.handleClickMic}
                                style={{ fontSize: '40px', color: '#282a65', cursor: 'pointer', caretColor: 'transparent' }} id="mic" />

                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ASRDemo


// WEBPACK FOOTER //
// ./src/asrUi/ASRDemo.js